(function (root) {
  'use strict';

  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var MIN_CHEST_CM = 70;
  var CHEST_TABLE = [
    { size: 'XS', max: 75 },
    { size: 'S', max: 80 },
    { size: 'M', max: 85 },
    { size: 'L', max: 92 },
    { size: 'XL', max: 100 },
    { size: '2XL', max: 105 },
    { size: '3XL', max: 110 },
    { size: '4XL', max: 115 },
    { size: '5XL', max: 120 }
  ];
  var HEIGHT_RANGES = ['150-155', '156-160', '161-165', '166-170', '171-175', '176-180'];
  var WEIGHT_TIERS = [40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90];
  var HW_TABLE = {
    40: ['S', 'S', 'XS', 'XS', 'XS', 'XS'],
    45: ['M', 'M', 'S', 'S', 'S', 'S'],
    50: ['L', 'M', 'M', 'S', 'S', 'S'],
    55: ['L', 'M', 'M', 'M', 'M', 'M'],
    60: ['XL', 'L', 'L', 'L', 'M', 'M'],
    65: ['2XL', 'XL', 'XL', 'L', 'L', 'L'],
    70: ['3XL', '2XL', '2XL', 'XL', 'XL', 'XL'],
    75: ['3XL', '2XL', '2XL', '2XL', '2XL', '2XL'],
    80: ['4XL', '4XL', '3XL', '3XL', '2XL', '2XL'],
    85: ['5XL', '5XL', '4XL', '4XL', '3XL', '3XL'],
    90: ['6XL', '6XL', '5XL', '5XL', '4XL', '4XL']
  };

  function normalizeSize(value) {
    var size = String(value || '').toUpperCase().replace(/[\s_-]/g, '');
    if (size === 'XXL') return '2XL';
    return size;
  }

  function chestSize(chestCm) {
    if (chestCm < MIN_CHEST_CM || chestCm > CHEST_TABLE[CHEST_TABLE.length - 1].max) return null;
    for (var i = 0; i < CHEST_TABLE.length; i += 1) {
      if (chestCm <= CHEST_TABLE[i].max) return CHEST_TABLE[i].size;
    }
    return null;
  }

  function normalizedWeight(weightKg) {
    var tier = Math.round(weightKg / 5) * 5;
    return tier >= 40 && tier <= 90 ? tier : null;
  }

  function heightIndex(heightCm) {
    if (heightCm < 150 || heightCm > 180) return null;
    if (heightCm <= 155) return 0;
    if (heightCm <= 160) return 1;
    if (heightCm <= 165) return 2;
    if (heightCm <= 170) return 3;
    if (heightCm <= 175) return 4;
    if (heightCm <= 180) return 5;
    return null;
  }

  function recommend(input) {
    var chest = Number(input.chestCm);
    var heightProvided = input.heightCm !== null && input.heightCm !== undefined && input.heightCm !== '';
    var weightProvided = input.weightKg !== null && input.weightKg !== undefined && input.weightKg !== '';
    if (!Number.isFinite(chest)) return { status: 'warning', message: 'Enter a valid chest measurement.' };

    var chestRecommendation = chestSize(chest);
    if (!chestRecommendation) {
      var chestRange = input.displayUnit === 'imperial' ? '27.6–47.2 in' : '70–120 cm';
      return { status: 'warning', message: 'This chest measurement is outside our ' + chestRange + ' size range. Please contact us for fit help.' };
    }
    if (heightProvided !== weightProvided) {
      return { status: 'warning', message: 'Enter both height and weight for the cross-check, or leave both optional fields blank.' };
    }

    var baseSize = chestRecommendation;
    var method = 'chest';
    var fitDetails = 'Recommended from your chest measurement.';

    if (heightProvided && weightProvided) {
      var height = Number(input.heightCm);
      var weight = Number(input.weightKg);
      var hIndex = heightIndex(height);
      var wTier = normalizedWeight(weight);
      if (!Number.isFinite(height) || !Number.isFinite(weight) || hIndex === null || wTier === null) {
        var crossCheckRange = input.displayUnit === 'imperial' ? '59.1–70.9 in and 88–198 lb' : '150–180 cm and 40–90 kg';
        return { status: 'warning', message: 'The optional height/weight cross-check supports ' + crossCheckRange + '. You can clear those fields and use chest-only sizing, or contact us.' };
      }

      var hwSize = HW_TABLE[wTier][hIndex];
      var chestIndex = SIZE_ORDER.indexOf(chestRecommendation);
      var hwIndex = SIZE_ORDER.indexOf(hwSize);
      var difference = Math.abs(chestIndex - hwIndex);
      method = 'cross-check';

      if (difference === 1) {
        baseSize = chestRecommendation;
      } else if (difference === 2 || difference === 3) {
        baseSize = SIZE_ORDER[Math.ceil((chestIndex + hwIndex) / 2)];
      } else if (difference >= 4) {
        return { status: 'warning', message: 'Your measurements point to very different sizes. Please remeasure your chest, height and weight or contact us before ordering.' };
      }
      fitDetails = 'Chest suggests ' + chestRecommendation + '; the optional height/weight cross-check suggests ' + hwSize + '.';
    }

    var needsSizeUp = Boolean(input.sizeUpAdjustment || input.hookClosure);
    var finalIndex = SIZE_ORDER.indexOf(baseSize) + (needsSizeUp ? 1 : 0);
    if (finalIndex > SIZE_ORDER.indexOf('5XL')) {
      return { status: 'warning', message: 'The product-specific closure adjustment is beyond our listed size range. Please contact us for fit help.' };
    }

    return {
      status: 'success',
      size: SIZE_ORDER[finalIndex],
      method: method,
      chestSize: chestRecommendation,
      sizeAdjusted: needsSizeUp,
      adjustmentReason: input.adjustmentReason || (input.hookClosure ? 'closure' : ''),
      details: fitDetails
    };
  }

  root.CoBinderSizeCore = { recommend: recommend, normalizeSize: normalizeSize };
  if (typeof document === 'undefined') return;

  function numberOrNull(input) {
    var value = input.value.trim();
    return value === '' ? null : Number(value);
  }

  function convert(value, unit, kind) {
    if (value === null) return null;
    if (unit === 'metric') return value;
    if (kind === 'weight') return value * 0.45359237;
    return value * 2.54;
  }

  function availableSizes(container) {
    try {
      return JSON.parse(container.dataset.availableSizes || '[]').map(normalizeSize);
    } catch (error) {
      return [];
    }
  }

  function selectProductSize(container, size) {
    var section = container.closest('.shopify-section') || document;
    var picker = section.querySelector('variant-radios');
    if (!picker) return false;

    var sizeFieldset = Array.prototype.find.call(picker.querySelectorAll('fieldset'), function (fieldset) {
      var legend = fieldset.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase() === 'size';
    });
    if (!sizeFieldset) return false;

    var normalized = normalizeSize(size);
    var target = Array.prototype.find.call(sizeFieldset.querySelectorAll('input[type="radio"]'), function (input) {
      return normalizeSize(input.value) === normalized;
    });
    if (!target) return false;
    var targetLabel = Array.prototype.find.call(sizeFieldset.querySelectorAll('label'), function (label) {
      return label.htmlFor === target.id;
    });
    if (target.disabled || target.classList.contains('disabled') || (targetLabel && targetLabel.classList.contains('disabled'))) return false;
    if (!target.checked) target.click();
    return target.checked;
  }

  function init(container) {
    if (container.dataset.coSizeInitialized === 'true') return;
    container.dataset.coSizeInitialized = 'true';
    var form = container.querySelector('.co-size-tool__form');
    var result = container.querySelector('[data-size-result]');
    var unit = 'metric';

    container.querySelectorAll('[data-unit]').forEach(function (button) {
      button.addEventListener('click', function () {
        unit = button.dataset.unit;
        container.querySelectorAll('[data-unit]').forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        container.querySelector('[data-chest-unit]').textContent = unit === 'metric' ? 'cm' : 'in';
        container.querySelector('[data-height-unit]').textContent = unit === 'metric' ? 'cm' : 'in';
        container.querySelector('[data-weight-unit]').textContent = unit === 'metric' ? 'kg' : 'lb';
        form.reset();
        result.hidden = true;
      });
    });

    form.addEventListener('reset', function () {
      result.hidden = true;
      result.removeAttribute('data-state');
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var output = recommend({
        chestCm: convert(numberOrNull(form.elements.chest), unit, 'length'),
        heightCm: convert(numberOrNull(form.elements.height), unit, 'length'),
        weightKg: convert(numberOrNull(form.elements.weight), unit, 'weight'),
        hookClosure: container.dataset.hookClosure === 'true',
        sizeUpAdjustment: container.dataset.sizeUpAdjustment === 'true',
        adjustmentReason: container.dataset.adjustmentReason || '',
        displayUnit: unit
      });

      result.hidden = false;
      result.dataset.state = output.status;
      if (output.status !== 'success') {
        result.innerHTML = '<h3>Please check your measurements</h3><p>' + output.message + '</p>';
        return;
      }

      var standalone = container.dataset.standalone === 'true';
      var productSizes = availableSizes(container);
      var unavailable = productSizes.length > 0 && productSizes.indexOf(normalizeSize(output.size)) === -1;
      var selected = !standalone && !unavailable && selectProductSize(container, output.size);
      var availability = standalone
        ? '<p>Use <strong>' + output.size + '</strong> as your starting size, then confirm availability on the product page.</p>'
        : unavailable
          ? '<p><strong>' + output.size + ' is not currently listed for this product.</strong> Contact us before choosing a different size.</p>'
          : selected
            ? '<p><strong>' + output.size + '</strong> has been selected in the size options.</p>'
            : '<p>Select <strong>' + output.size + '</strong> in the size options above.</p>';

      result.innerHTML = '<h3>Your suggested size: <span class="co-size-tool__result-size">' + output.size + '</span></h3>' +
        availability;
      window.requestAnimationFrame(function () {
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-co-size-tool]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})(typeof window !== 'undefined' ? window : globalThis);
